import React, { HTMLAttributes } from 'react';

import { motion, MotionProps } from 'framer-motion';

export const DEFAULT_TRANSITION_DURATION_SECONDS = 0.5;

// Allow extra DIV props like className, id, etc. (as long as they don't interfere with motion props)
type Props = MotionProps & {
  [K in Exclude<keyof HTMLAttributes<HTMLDivElement>, keyof MotionProps>]?: HTMLAttributes<HTMLDivElement>[K]
} & {
  children: React.ReactNode;
  skipFade?: boolean;
  durationSeconds?: number;
};
export function FadeInComponent ({ children, durationSeconds, skipFade, ...rest }: Props) {
  return (
    <motion.div
      layout
      initial={skipFade ? false : 'hidden'}
      animate="visible"
      exit="hidden"
      transition={{ duration: durationSeconds || DEFAULT_TRANSITION_DURATION_SECONDS }}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
